import { SvgIcon, SvgIconProps } from '@mui/material';

/** @deprecated Use theme-next icons or move into theme-next folder if it doesn't exists */
export const SortingArrowDownIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.6666 10L15.4916 8.825L10.8333 13.475V3.33333H9.16659V13.475L4.51659 8.81667L3.33325 10L9.99992 16.6667L16.6666 10Z"
            />
        </SvgIcon>
    );
};
